import React from 'react';

import { Skeleton } from '@/components/ui/Skeleton';

const OfferLoading = () => {
  return (
    <div className="flex flex-col gap-y-4 lg:gap-y-5">
      <Skeleton className="h-[186px] w-full lg:h-[148px]" />
      <Skeleton className="h-[960px] w-full" />
    </div>
  );
};

export default OfferLoading;
